// client/src/coms/voip/sharePermissions.js
// Direct (P2P) shares bypass the SFU, so the server cannot stop a modified client from sending one.
// Receivers check the sender's LiveKit permissions instead: they are issued by our token endpoint
// (role / timeout aware) and signed by the server, so a sender cannot fake them.

// livekit protocol TrackSource values as they appear in ParticipantPermission.canPublishSources
const SOURCE = { camera: 1, microphone: 2, screen: 3, screen_audio: 4 };

export function participantMayShare(permissions, kind = 'screen') {
  if (!permissions) return true; // unknown (not yet received): same rule as the sender side
  if (permissions.canPublish === false) return false;
  const sources = Array.isArray(permissions.canPublishSources) ? permissions.canPublishSources.map(Number) : [];
  if (sources.length === 0) return true; // LiveKit: empty list with canPublish = every source allowed
  return sources.includes(kind === 'camera' ? SOURCE.camera : SOURCE.screen);
}

export function remoteMayShare(room, identity, kind = 'screen') {
  try {
    const p = room && room.remoteParticipants ? room.remoteParticipants.get(String(identity)) : null;
    if (!p) return false; // not in the room: never accept media from them
    return participantMayShare(p.permissions, kind);
  } catch {
    return true;
  }
}
